const COMMON_PREFIX = "store/menuReducer";

export const SET_PROCESSING = `${COMMON_PREFIX}/SET_PROCESSING`;
export const FETCH_GATES = `${COMMON_PREFIX}/FETCH_GATES`;
export const GAME_COMPLETE = `${COMMON_PREFIX}/GAME_COMPLETE`;
export const GAME_INCOMPLETE = `${COMMON_PREFIX}/GAME_INCOMPLETE`;